import React from 'react'
import AnswerItem from './AnswerItem'

import styles from './AnswerList.css'

function AnswerList ({ answers }) {
  return (
    <div className={styles.root}>
      {
        answers.map((answer, index) =>
          <AnswerItem
            key={answer.answerId}
            index={index+1}
            question={answer.question}
            answer={answer.answer}
            userAnswer={answer.userAnswer}
          />
        )
      }
    </div>
  )
}


export default AnswerList



/** WEBPACK FOOTER **
 ** ./src/components/Report/AnswerList.js
 **/